var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "cms-layout" } },
    [
      _c("div", { staticClass: "app-topbar" }, [
        _c(
          "div",
          { staticClass: "title-bar" },
          [
            _c("div", { staticClass: "logo" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.navigateHome()
                    },
                  },
                },
                [_c("i", { staticClass: "img logo-aveco-white-36h" })]
              ),
            ]),
            _c("app-switcher", { attrs: { current: "loggers" } }),
            _c("div", { staticClass: "user" }, [
              _c("div", { staticClass: "user-info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$user.firstName) +
                      " " +
                      _vm._s(_vm.$user.lastName)
                  ),
                ]),
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.logout()
                      },
                    },
                  },
                  [_vm._v("Uitloggen")]
                ),
              ]),
              _c("div", { staticClass: "avatar" }, [
                _vm._v(_vm._s(_vm._f("userInitials")(_vm.$user))),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "nav",
        { class: { show: _vm.slideMenuVisible }, attrs: { id: "cms-sidebar" } },
        [
          _c("div", { staticClass: "toggle-menu" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.slideMenuVisible = !_vm.slideMenuVisible
                  },
                },
              },
              [_c("i", { staticClass: "magicon-menu" })]
            ),
          ]),
          _c(
            "router-link",
            { attrs: { to: _vm.resolvedHomeRoute, id: "client-logo" } },
            [_c("i", { staticClass: "svg" })]
          ),
          _c(
            "cms-menu",
            [
              _c("cms-menu-group", { attrs: { title: "Menu" } }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.logout()
                      },
                    },
                  },
                  [_vm._v("Uitloggen")]
                ),
              ]),
              _c("cms-menu-item", {
                attrs: {
                  title: "Overzicht loggers",
                  icon: "magicon-tiles",
                  route: "loggers",
                },
              }),
              _c("cms-menu-item", {
                attrs: {
                  title: "Selectie maken",
                  icon: "magicon-ok-circle",
                  route: "select-loggers",
                },
              }),
              _vm.isAdminOrAdvisor
                ? _c("cms-menu-item", {
                    attrs: {
                      title: "Reparaties",
                      icon: "entypo-tools",
                      route: "repairs",
                    },
                  })
                : _vm._e(),
              _c("cms-menu-item", {
                attrs: {
                  title: "Acties",
                  icon: "entypo-flag",
                  route: "actions",
                },
              }),
              _vm.isAdminOrAdvisor
                ? _c("cms-menu-item", {
                    attrs: {
                      title: "Projecten",
                      icon: "entypo-archive",
                      route: "projects",
                    },
                  })
                : _vm._e(),
              _vm.isAdminOrAdvisor
                ? _c("cms-menu-item", {
                    attrs: {
                      title: "Logger types",
                      icon: "magicon-dots-hr",
                      route: "logger-types",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "cms-content-wrapper" } }, [
        _c(
          "div",
          { attrs: { id: "cms-top-bar" } },
          [
            _c("cms-breadcrumbs", {
              attrs: {
                items: _vm.$breadcrumb.get(),
                "active-route": _vm.$route,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { attrs: { id: "cms-content-view" } },
          [_c("router-view")],
          1
        ),
      ]),
      _c("transition", { attrs: { name: "fade", duration: 200 } }, [
        _vm.$modal.visible.length
          ? _c(
              "div",
              { staticClass: "cms-shader", on: { click: _vm.onShaderClick } },
              [
                _c("modal-container", {
                  ref: "modalContainer",
                  staticClass: "modal-container",
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }